import { BaseApiRouteService } from "mrb/core";

class LoadioAlbumApiRouteService extends BaseApiRouteService {
    constructor() {
        super("loadio/albums");
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields}`, filter);
    }

    getAllSongs(id, options) {
        return super.get(`${this.base}/{id}/tracks/all{?embed,fields}`, id, options);
    }

    updateActiveStatus(id, value) {
        return super.update(`${this.base}/{id}/active{?value}`, {
            id: id,
            value: value,
        });
    }
}

export default LoadioAlbumApiRouteService;
